import MessageBoxReader from "../components/user/MessageBoxReader";
function MessageBoxPage() {
  return (
    <div className="page p-1">
      <MessageBoxReader />
    </div>
  );
}

export default MessageBoxPage;
